// Audit entries store before/after as free text. Most are a short transition
// ("Pending → Verified"), but settings changes store the whole row as JSON, which
// printed as an unreadable blob. This turns either form into one short line.

const IGNORED_KEYS = new Set(["id", "created_at", "updated_at"]);

function parseObject(raw?: string): Record<string, unknown> | null {
  if (!raw) return null;
  const t = raw.trim();
  if (!t.startsWith("{")) return null;
  try {
    const v = JSON.parse(t);
    return v && typeof v === "object" && !Array.isArray(v) ? (v as Record<string, unknown>) : null;
  } catch {
    return null;
  }
}

function label(key: string): string {
  const s = key.replace(/_/g, " ").trim();
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function show(v: unknown): string {
  if (v === null || v === undefined || v === "") return "none";
  if (typeof v === "boolean") return v ? "on" : "off";
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
}

/** "Platform fee 8 → 9 · Maintenance mode off → on", or "Pending → Verified". null when there is nothing to say. */
export function describeChange(previous?: string, next?: string): string | null {
  const a = parseObject(previous);
  const b = parseObject(next);
  if (a || b) {
    const keys = Array.from(new Set([...Object.keys(a ?? {}), ...Object.keys(b ?? {})])).filter((k) => !IGNORED_KEYS.has(k));
    const changed = keys.filter((k) => JSON.stringify(a?.[k]) !== JSON.stringify(b?.[k]));
    if (changed.length === 0) return "No visible changes";
    const parts = changed.slice(0, 3).map((k) => `${label(k)} ${show(a?.[k])} → ${show(b?.[k])}`);
    if (changed.length > 3) parts.push(`+${changed.length - 3} more`);
    return parts.join(" · ");
  }
  if (!previous && !next) return null;
  if (previous && next) return `${previous} → ${next}`;
  return previous || next || null;
}
